import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { BREAKPOINTS } from './breakpoints.js';

export function initProductListingBlock() {
    const carousels = document.querySelectorAll('.cmp-featuredproductlisting.swiper');

    carousels.forEach((carousel) => {
        const nextEls = Array.from(carousel.querySelectorAll('.swiper-button-next-desktop, .swiper-button-next-mobile'));
        const prevEls = Array.from(carousel.querySelectorAll('.swiper-button-prev-desktop, .swiper-button-prev-mobile'));
        const paginationEl = carousel.querySelector('.swiper-pagination');

        new Swiper(carousel, {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            navigation: {
                nextEl: nextEls,
                prevEl: prevEls,
            },
            pagination: {
                el: paginationEl,
                clickable: true,
            },
            breakpoints: {
                [BREAKPOINTS.MEDIUM]: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                },
                [BREAKPOINTS.LARGE]: {
                    slidesPerView: 4.5,
                    spaceBetween: 10,
                }
            }
        });
    });
}
